/**
 * Metric Card Component per UX Spec page 3
 * - Light-gray (#F1EFE8) background
 * - 18px number in tool colour
 * - 9px label below
 * - Secondary KPIs — 4 per row on desktop, 2 on tablet
 */

interface MetricCardProps {
  value: string | number;
  label: string;
  className?: string;
}

export function MetricCard({ value, label, className = '' }: MetricCardProps) {
  return (
    <div className={`bg-surface-warm rounded-card p-3 text-center ${className}`}>
      <div className="text-lg font-medium text-t1-primary">{value}</div>
      <div className="text-[9px] text-gray-600 mt-0.5">{label}</div>
    </div>
  );
}
